export enum UserRole {
  NONE = 'none',
  TRANSLATOR = 'translator',
  TRUSTED_TRANSLATOR = 'trusted_translator',
  REVIEWER = 'reviewer',
  MANAGER = 'manager',
  OWNER = 'owner',
  DEVELOPER = 'developer',
}
